module.exports = __webpack_public_path__ + "static/sstep3-05916348bf8826fd8118d47d7d1ad08c.png";